import { render, staticRenderFns } from "./AutoLogin.vue?vue&type=template&id=56a01ffe"
import script from "./AutoLogin.vue?vue&type=script&lang=js"
export * from "./AutoLogin.vue?vue&type=script&lang=js"
import style0 from "./AutoLogin.vue?vue&type=style&index=0&id=56a01ffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports